<template>
  <b-modal
    :id="id"
    ref="imageModal"
    size="lg"
    centered
    hide-footer
    hide-header
    modal-class="image-modal"
  >
    <div class="image-container">
      <button
        class="close-button"
        @click="closeViewer()"
      >
        ✖
      </button>
      <img
        :src="imageUrl"
        class="viewer-image"
      >
    </div>
  </b-modal>
</template>

<script>
export default {
  name: 'ImageViewer',

  props: {
    imageUrl: {
      type: String,
      default: '',
    },
    id: {
      type: String,
      default: 'image-viewer',
    },
  },

  methods: {

    closeViewer() {
      this.$bvModal.hide(this.id);
    },
  },
};
</script>

<style scoped>

/* Image Viewer */
.image-container {
  position: relative;
  display: flex;
  justify-content: center;
  align-items: center;
  max-height: 90vh;
}

.viewer-image {
  max-width: 100%;
  max-height: 80vh;
  width: auto;
  height: auto;
  object-fit: contain;
}
.image-container .close-button {
  position: absolute;
  top: 20px;
  right: 20px;
  font-size: 24px;
  color: white;
  background: rgba(0, 0, 0, 0.5);
  border: none;
  border-radius: 50%;
  width: 32px;
  height: 32px;
  line-height: 30px;
  text-align: center;
  cursor: pointer;
  z-index: 10000;
}
.image-container .close-button:hover {
  background: rgba(110, 107, 107, 0.6);
}
</style>
